import get from 'lodash/get';

/* Libs */
import Segment from '../index';

/* Utils */
import {getTotalCreditAdjustments} from '@utils/cart';

/* Types */
import {BreakdownItem, Cart, Item} from 'types/cart.types';

/**
 * -------------------------------------------------------------------------------------
 * These are just "actions" that are consolidated in one place that
 * will return your properties structure. Just "method" out what you
 * need to handle.
 */

export function getCartProperties(cart: Cart) {
  const breakdown = get(cart, 'breakdown', {});
  const items = get(cart, 'items', []);
  const breakdownItems = get(breakdown, 'items', []) || [];
  // try to get partner name from various areas of cart :-(
  const getName = () => cart.partnerName || get(cart, 'partner.name', '') || get(cart, 'partner.landingSeoName', '') || '';
  // try to get additional info by matching in another part of cart
  const getAdditionalItemAttributes = (id: number) => items.find((item: Item) => item.skuId === id);

  // partner colate
  const partnerObject = get(cart, 'partner', false);
  const partner = partnerObject
    ? {
        partner_id: partnerObject.id,
        partner_name: getName(),
      }
    : null;

  const products = breakdownItems.map((item: BreakdownItem) => {
    const {skuId} = item;
    return {
      sku_id: skuId,
      base_price: item.amount / 100,
      category: item.category,
      is_remote: get(getAdditionalItemAttributes(skuId), 'remote', false),
      image_url: get(getAdditionalItemAttributes(skuId), 'heroImageUrl', false),
      name: item.name,
      partner,
      physical_product: item.isProduct,
      requires_installation: item.requiresInstallation,
    };
  });

  const {amount: creditsAmount = 0} = getTotalCreditAdjustments(cart);

  return {
    cart_id: cart.id,
    amount: (breakdown as BreakdownItem).total / 100,
    savings: (breakdown as BreakdownItem).totalSavings,
    products,
    ...(cart.workflow && {workflow: cart.workflow}),
    token: cart.token,
    credits_amount: creditsAmount / 100,
  };
}

export const SegmentTrackingAction = {
  /* Landing Page Sku */
  checkoutStarted(cart: Cart) {
    const payload = {
      ...getCartProperties(cart),
    };

    Segment.track('Checkout Started', payload);
  },
};
